import { useContext, useState, useEffect, useRef } from 'react';
import { SubmissionContext } from './SubmissionFormContext';
import { getFormFields, getAnimationPrompt, getFormResponses } from '../services/apiService';
import { CustomFormField } from '../services/interfaces';
import parse from 'html-react-parser';
import { TextBox, TextBoxChangeEvent, TextBoxProps, MaskedTextBox, ColorPicker, ColorPickerChangeEvent,InputPrefix, InputSuffix, TextArea} from '@progress/kendo-react-inputs';
import { DropDownList,DropDownListFilterChangeEvent, DropDownListChangeEvent, ListItemProps, MultiSelect, MultiSelectChangeEvent, MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faXmark, faTriangleExclamation, faMagicWandSparkles} from '@fortawesome/free-solid-svg-icons';
import { SubmitCustomInfo } from './InfoBoxes';
import { Button } from "@progress/kendo-react-buttons"
import { AdCopyAssistant } from "./AdCopyAssistant"
import { adCopyAssistanFields, AdCopyAssistantProps,NewSize } from '../services/interfaces';
import { elements } from '@progress/kendo-react-common';
import { DatePicker, DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { IntlProvider, load, loadMessages } from '@progress/kendo-react-intl';
import { PageContext } from './PageContext';
import { UserContext } from './UserContext';

interface customFieldData{
    index:number, 
    text:string, 
    value:string, 
    weight:string
}

function CustomForm(){
    const subContext=useContext(SubmissionContext);
    const [fieldsSet, setFieldsSet]=useState(false);
    const [respSet, setRespSet]=useState(false);
    const pageContext = useContext(PageContext);
    const [asstShow, setAsstShow]=useState(false);
    const userContext=useContext(UserContext);
    //const [asstField, setAsstField]=useState(0);
    const asstField = useRef(0);
    const asstResponse = useRef("");
    const [asstProps, setAsstProps]=useState<AdCopyAssistantProps>({
        presets:{
            formType:"NEW",
            action:"",
            unitType:"",
            maxLength:10,
            emojis:false,
            hashtags:false,
            style:"",
            prompt:""
        },
        onConfirm:updateFieldValue,
        onClose:hideAsst
    })

    
    function hideAsst(){
        setAsstShow(false);
    }

    function showAsst(events: React.MouseEvent<HTMLButtonElement, MouseEvent>, field:number): void {
        events?.preventDefault();
        console.log("Field:" + field);
        setAsstShow(true);
        asstField.current=field;
        //setAsstField(()=>{return field;});
    }

    function setActiveField(field:number){
       // setAsstField(field);
    }

    function updateFieldValue(retval:string){
        //console.log("AI Response: " + retval);
        //console.log("Field:" + asstField.current);
        asstResponse.current=retval;
        //handleAIResponse();
        //setAdCopy(retval);
        //subContext?.setSubmitForm(prevObject=>({...prevObject,adCopy:retval}));        
        setAsstShow(false);
    }

    const handleAIResponse=()=>{
        //console.log("Field: " + asstField.current);
        //console.log("AI Response: " + asstResponse.current);
        const prevValue = subContext?.customFieldData;
        //console.log(prevValue);
        subContext?.setCustomFieldData({ ...prevValue, [asstField.current]: asstResponse.current });
    }

    const handleChange = (fieldId:number, value:string) => {
        console.log(subContext?.customFieldData);
        subContext?.setCustomFieldData({ ...subContext.customFieldData, [fieldId]: value });
    };  

    const handleDropDownChange=(fieldId:number, event:DropDownListChangeEvent)=>{
        subContext?.setCustomFieldData({ ...subContext.customFieldData, [fieldId]: event.target.value });
    }

    const handleMultiSelectChange=(fieldId:number, event:MultiSelectChangeEvent)=>{
        console.log(event.target.value);
        const selVal = JSON.stringify(event.target.value);
        console.log(selVal);
        subContext?.setCustomFieldData({ ...subContext.customFieldData, [fieldId]: selVal });
    }

    const validateText=(fieldId:number)=>{
        if (subContext?.customFieldData[fieldId] && subContext?.customFieldData[fieldId]!==null && subContext?.customFieldData[fieldId]!==""){            
            return true;
        }else{
            return false;
        }
    }

    const getMultiValue=(fieldId:number)=>{
        const savedValue=subContext?.customFieldData[fieldId]
        //console.log(savedValue);
        if (savedValue!="" && savedValue){
            if (savedValue[0]=='Standard Static'){
                //console.log(savedValue);
            }else{
                //console.log(savedValue);
                const jsonVal = JSON.parse(savedValue);
                return jsonVal;
            }
        }else{
            return []
        }

    }

    // const saveFieldSet=(fields:CustomFormField[])=>{
    //     subContext?.setFields(fields);
    // }

    const clearUnusedFieldVals=()=>{
        if (subContext?.fields.length||0>0){
            subContext?.fields.forEach((field: CustomFormField) =>{
                if (field.dependantField!=0){
                    //this fields has a dependancy
                    const depField = subContext?.fields.find(obj=>obj.fieldID==field.dependantField);
                    var depIsSelected=false;
                    switch (depField?.type){
                        case "RadioButtonList":
                            const selValue = (subContext?.customFieldData[field.dependantField] as unknown) as {index:number, text:string, value:string, weight:string} || {index: -1, text: '', value: '', weight: ''};
                            var selIdx="";
                            if (selValue.index!=null && selValue.index>-1){
                                selIdx = selValue.index.toString();
                            }
                            if (selIdx){
                                if (field.dependantValue.toString().includes("|")){
                                    //multiple dependant values
                                    const depVals = field.dependantValue.toString().split("|");
                                    depVals.forEach(val =>{
                                        if (val === selIdx.toString()){depIsSelected=true;}
                                    })
                                }else{
                                    //just one dependant value
                                    if (field.dependantValue.toString() == selIdx.toString()) { depIsSelected = true; }
                                }
                            }
                            break;
                        case "CheckBoxList":
                            const depFieldVal = subContext.customFieldData[field.dependantField];                                
                                if (depFieldVal){
                                    const arrValue = JSON.parse(depFieldVal) as unknown as Array<customFieldData>
                                    if (arrValue.length>0 && arrValue[0].index!==-1){
                                         arrValue.forEach(obj => {
                                             if (obj.index!=-1){
                                                 //console.log(obj);
                                                 var arrIndex=obj.index;
                                                 if (obj.index){
                                                    if (field.dependantValue.includes("|")){
                                                        //this field has multiple valid dependant values
                                                        var splitVal = field.dependantValue.split("|");
                                                        var found = splitVal.find(entry=>entry===arrIndex.toString());
                                                        if (found){
                                                            depIsSelected=true;
                                                        }
                                                    }else{
                                                        //this field only has one valid dependant value
                                                         if (field.dependantValue.toString() === arrIndex.toString()) { depIsSelected = true; }
                                                    }
                                                 }
                                             }
                                         });
                                    }
                                }
                            break;
                    }
                    if (!depIsSelected){
                        var newFieldData = subContext.customFieldData;
                        delete newFieldData[field.fieldID];
                        //console.log(newFieldData);
                        subContext.setCustomFieldData(newFieldData);
                        // //the dependant field is not selecteed so clear any previously set value for this field.
                        // if (subContext.customFieldData[field.fieldID] && subContext.customFieldData[field.fieldID]!==""){
                        //     switch (field.type){
                        //         case "RadioButtonList":
                        //             subContext?.setCustomFieldData({ ...subContext.customFieldData, [field.fieldID]: "{}" });
                        //             break;
                        //         case "CheckBoxList":
                        //             subContext?.setCustomFieldData({ ...subContext.customFieldData, [field.fieldID]: "[]" });
                        //             break;
                        //         case "TextBox":
                        //         case "TextBoxAI":
                        //         case "LongText":
                        //         case "LongTextAI":
                        //         case "Email":
                        //             subContext?.setCustomFieldData({ ...subContext.customFieldData, [field.fieldID]: "" });
                        //             break;
                        //     }
                        //     console.log("This field has a value set");
                        //     console.log(field);
                        //     //clear the field data value
                        //     subContext?.setCustomFieldData({ ...subContext.customFieldData, [field.fieldID]: "" });
                        //}
                    }
                }
            });
        }
    }

    const getRadioValue=(fieldId:number)=>{
        if (typeof(subContext?.customFieldData[fieldId])==="string"){
            return (JSON.parse(subContext?.customFieldData[fieldId]||"{}"));
        }else{
            return (subContext?.customFieldData[fieldId]);
        }
    }


    function renderField(field:CustomFormField){
        //console.log(field);
        
        if (field.dependantField==309){
            //console.log(field);
            //console.log(subContext?.customFieldData);   
        }
       
        switch(field.type){
            case "TextBox":
            case "TextBoxAI":
                if (field.dependantField!=0){
                    if (field.fieldID==91){
                        console.log(field);
                    }
                    //console.log(field.dependantField);
                    const depField = subContext?.fields.find(obj=>obj.fieldID==field.dependantField);
                    var depIsSelected=false;
                    switch (depField?.type){
                        case "RadioButtonList":
                            const selValue = (JSON.parse(subContext?.customFieldData[field.dependantField] || "{}") as unknown) as {index:number, text:string, value:string, weight:string} || {index: -1, text: '', value: '', weight: ''};
                            //console.log(selValue);
                            
                            var selIdx="";
                            if (selValue.index!=null && selValue.index>-1){
                                selIdx = selValue.index.toString();
                            }
                            if (selIdx){
                                if (field.dependantValue.toString().includes("|")){
                                    //multiple dependant values
                                    const depVals = field.dependantValue.toString().split("|");
                                    depVals.forEach(val =>{
                                        if (val === selIdx.toString()){depIsSelected=true;}
                                    })
                                }else{
                                    //just one dependant value
                                    if (field.dependantValue.toString() == selIdx.toString()) { depIsSelected = true; }
                                }
                            }
                            break;
                        case "CheckBoxList":
                            if (subContext){
                                const depFieldVal = subContext.customFieldData[field.dependantField];                                
                                if (depFieldVal){
                                    const arrValue = JSON.parse(depFieldVal) as unknown as Array<customFieldData>
                                    if (arrValue.length>0 && arrValue[0].index!==-1){
                                        arrValue.forEach(obj => {
                                            if (obj.index!=-1){
                                                //console.log(obj);
                                                var arrIndex=obj.index;
                                                if (obj.index){
                                                    if (field.dependantValue.includes("|")){
                                                        //this field has multiple valid dependant values
                                                        var splitVal = field.dependantValue.split("|");
                                                        var found = splitVal.find(entry=>entry===arrIndex.toString());
                                                        if (found){
                                                            depIsSelected=true;
                                                        }
                                                    }else{
                                                        //this field only has one valid dependant value
                                                        if (field.dependantValue.toString() === arrIndex.toString()) { depIsSelected = true; }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            break;
                    }                                        
                    if (depIsSelected){
                        //dependant value set
                        const id="atolField-"+field.fieldID.toString();
                        return(
                            <div key={field.fieldID}>
                                <label className='mt-3'>{parse(field.label)}</label>
                                <TextBox
                                    id={id}
                                    key={field.fieldID}
                                    value={subContext?.customFieldData[field.fieldID]||""}
                                    onChange={(e)=>handleChange(field.fieldID, e.target.value?.toString() || '')}
                                    maxLength={field.maxLength}
                                    className={'mt-2 ' + id}
                                    valid={field.required?validateText(field.fieldID):true}
                                    // prefix={() => (
                                    //     <InputPrefix>
                                    //         {field.required ? (validateText(field.fieldID) ? null:<FontAwesomeIcon style={{paddingLeft:"8px",color:"red"}} icon={faTriangleExclamation} />):null}
                                    //     </InputPrefix>
                                    // )}
                                />
                            {field.type=="TextBoxAI"?<Button onClick={(e) => showAsst(e, field.fieldID)}><FontAwesomeIcon icon={faMagicWandSparkles}></FontAwesomeIcon>&nbsp;Ad Copy Assistant</Button>:null}
                            </div>
                        )
                    }else{
                        //clear the value if the dependant field is not set.
                        //clearDependantValue(field);
                        return null;
                    }
                }else{
                    const id="atolField-"+field.fieldID.toString();
                    return(
                        
                        <div key={field.fieldID}>
                            <label className='mt-3'>{parse(field.label)}</label>
                            <TextBox
                                id={"atolField-"+ field.fieldID}
                                key={field.fieldID}
                                value={subContext?.customFieldData[field.fieldID]||""}
                                onChange={(e)=>handleChange(field.fieldID,e.target.value?.toString() || '')}
                                maxLength={field.maxLength}
                                className={'mt-2 ' + id}
                                valid={field.required?validateText(field.fieldID):true}
                            />
                            {field.type=="TextBoxAI"?<Button onClick={(e) => showAsst(e, field.fieldID)}><FontAwesomeIcon icon={faMagicWandSparkles}></FontAwesomeIcon>&nbsp;Ad Copy Assistant</Button>:null}
                        </div>
                    )    
                }
                break;
            case "LongText":
            case "LongTextAI":
                if (field.dependantField!=0){
                    //console.log(field.dependantField);
                    const depField = subContext?.fields.find(obj=>obj.fieldID==field.dependantField);
                    if (field.dependantField==14000){
                        console.log(depField);
                    }
                    var depIsSelected=false;
                    switch (depField?.type){
                        case "RadioButtonList":
                            const selValue = (subContext?.customFieldData[field.dependantField] as unknown) as {index:number, text:string, value:string, weight:string} || {index: -1, text: '', value: '', weight: ''};
                            //console.log(selValue);
                            var selIndex = selValue.index;
                            if (field.dependantValue.toString().includes("|")){
                                //multiple dependant values
                                const depVals = field.dependantValue.toString().split("|");
                                depVals.forEach(val =>{
                                    if (val === selIndex.toString()){depIsSelected=true;}
                                })
                            }else{
                                //just one dependant value
                                if (field.dependantValue.toString() == selIndex.toString()) { depIsSelected = true; }
                            }
                            //if (field.dependantValue.toString() === selIndex.toString()) { depIsSelected = true; }
                            break;
                        case "CheckBoxList":
                            if (subContext){
                                const depFieldVal = subContext.customFieldData[field.dependantField];                                
                                if (depFieldVal){
                                    const arrValue = JSON.parse(depFieldVal) as unknown as Array<customFieldData>
                                    if (arrValue && arrValue[0].index!==-1){
                                        arrValue.forEach(obj => {
                                            if (obj.index!=-1){
                                                console.log(obj);
                                                var arrIndex=obj.index;
                                                if (obj.index){
                                                    if (field.dependantValue.includes("|")){
                                                        //this field has multiple valid dependant values
                                                        var splitVal = field.dependantValue.split("|");
                                                        var found = splitVal.find(entry=>entry===arrIndex.toString());
                                                        if (found){
                                                            depIsSelected=true;
                                                        }
                                                    }else{
                                                        //this field only has one valid dependant value
                                                        if (field.dependantValue.toString() === arrIndex.toString()) { depIsSelected = true; }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            break;
                    }                                        
                    if (depIsSelected){                    
                        return(
                            <div key={field.fieldID}>
                                <label className='mt-3'>{parse(field.label)}</label>
                                <TextArea
                                    id={"atolField-"+ field.fieldID}
                                    key={field.fieldID}
                                    value={subContext?.customFieldData[field.fieldID]||""}
                                    onChange={(e)=>handleChange(field.fieldID,e.target.value?.toString() || '')}
                                    maxLength={field.maxLength}
                                    className={'mt-2 atolField-'+field.fieldID.toString()}
                                    valid={field.required?validateText(field.fieldID):true}
                                />
                                {field.type=="LongTextAI"?<Button onClick={(e) => showAsst(e, field.fieldID)}><FontAwesomeIcon icon={faMagicWandSparkles}></FontAwesomeIcon>&nbsp;Ad Copy Assistant</Button>:null}
                            </div>
                        )
                    }else{
                        return null;
                    }
                }else{
                    return(
                        <div key={field.fieldID}>
                            <label className='mt-3'>{parse(field.label)}</label>
                            <TextArea
                                id={"atolField-"+ field.fieldID}
                                key={field.fieldID}
                                value={subContext?.customFieldData[field.fieldID]||""}
                                onChange={(e)=>handleChange(field.fieldID,e.target.value?.toString() || '')}
                                maxLength={field.maxLength}
                                className={'mt-2 atolField-'+field.fieldID.toString()}
                            />
                            {field.type=="LongTextAI"?<Button onClick={(e) => showAsst(e, field.fieldID)}><FontAwesomeIcon icon={faMagicWandSparkles}></FontAwesomeIcon>&nbsp;Ad Copy Assistant</Button>:null}
                        </div>
                    )
                }
                break;
            case "Email":
                if (field.dependantField!=0){
                    //console.log(field.dependantField);
                    const depField = subContext?.fields.find(obj=>obj.fieldID==field.dependantField);
                    
                    var depIsSelected=false;
                    switch (depField?.type){
                        case "RadioButtonList":
                            const selValue = (subContext?.customFieldData[field.dependantField] as unknown) as {index:number, text:string, value:string, weight:string} || {index: -1, text: '', value: '', weight: ''};
                            //console.log(selValue);
                            var selIdx="";
                            if (selValue.index!=null && selValue.index>-1){
                                selIdx = selValue.index.toString();
                            }
                            if (selIdx){
                                if (field.dependantValue.toString().includes("|")){
                                    //multiple dependant values
                                    const depVals = field.dependantValue.toString().split("|");
                                    depVals.forEach(val =>{
                                        if (val === selIdx.toString()){depIsSelected=true;}
                                    })
                                }else{
                                    //just one dependant value
                                    if (field.dependantValue.toString() == selIdx.toString()) { depIsSelected = true; }
                                }
                            }
                            break;
                        case "CheckBoxList":
                            if (subContext){
                                const depFieldVal = subContext.customFieldData[field.dependantField];                                
                                if (depFieldVal){
                                    const arrValue = JSON.parse(depFieldVal) as unknown as Array<customFieldData>
                                    if (arrValue.length>0 && arrValue[0].index!==-1){
                                        arrValue.forEach(obj => {
                                            if (obj.index!=-1){
                                                //console.log(obj);
                                                var arrIndex=obj.index;
                                                if (obj.index){
                                                    if (field.dependantValue.includes("|")){
                                                        //this field has multiple valid dependant values
                                                        var splitVal = field.dependantValue.split("|");
                                                        var found = splitVal.find(entry=>entry===arrIndex.toString());
                                                        if (found){
                                                            depIsSelected=true;
                                                        }
                                                    }else{
                                                        //this field only has one valid dependant value
                                                        if (field.dependantValue.toString() === arrIndex.toString()) { depIsSelected = true; }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            break;
                    }
                    if (depIsSelected){
                        return(
                        <div key={field.fieldID}>
                            <label className='mt-3'>{parse(field.label)}</label>
                            <TextBox
                                id={"atolField-"+ field.fieldID}
                                key={field.fieldID}
                                value={subContext?.customFieldData[field.fieldID]||""}
                                onChange={(e)=>handleChange(field.fieldID,e.target.value?.toString() || '')}
                                maxLength={field.maxLength}
                                className={'mt-2 atolField-'+field.fieldID.toString()}
                            />
                        </div>
                    )
                    }else{
                        return null;
                    }
                }else{
                    return(
                        <div key={field.fieldID}>
                            <label className='mt-3'>{parse(field.label)}</label>
                            <TextBox
                                id={"atolField-"+ field.fieldID}
                                key={field.fieldID}
                                value={subContext?.customFieldData[field.fieldID]||""}
                                onChange={(e)=>handleChange(field.fieldID,e.target.value?.toString() || '')}
                                maxLength={field.maxLength}
                                className={'mt-2 atolField-'+field.fieldID.toString()}
                            />
                        </div>
                    )
                }  
                break;
            case "URL":
                if (field.dependantField!=0){
                    //console.log(field.dependantField);
                    const depField = subContext?.fields.find(obj=>obj.fieldID==field.dependantField);
                    var depIsSelected=false;
                    switch (depField?.type){
                        case "RadioButtonList":
                            const selValue = (subContext?.customFieldData[field.dependantField] as unknown) as {index:number, text:string, value:string, weight:string} || {index: -1, text: '', value: '', weight: ''};
                            //console.log(selValue);
                            var selIdx="";
                            if (selValue.index!=null && selValue.index>-1){
                                selIdx = selValue.index.toString();
                            }
                            if (selIdx){
                                if (field.dependantValue.toString().includes("|")){
                                    //multiple dependant values
                                    const depVals = field.dependantValue.toString().split("|");
                                    depVals.forEach(val =>{
                                        if (val === selIdx.toString()){depIsSelected=true;}
                                    })
                                }else{
                                    //just one dependant value
                                    if (field.dependantValue.toString() == selIdx.toString()) { depIsSelected = true; }
                                }
                            }
                            break;
                        case "CheckBoxList":
                            if (subContext){
                                const depFieldVal = subContext.customFieldData[field.dependantField];                                
                                if (depFieldVal){
                                    const arrValue = JSON.parse(depFieldVal) as unknown as Array<customFieldData>
                                    if (arrValue.length>0 && arrValue[0].index!==-1){
                                        arrValue.forEach(obj => {
                                            if (obj.index!=-1){
                                                //console.log(obj);
                                                var arrIndex=obj.index;
                                                if (obj.index){
                                                    if (field.dependantValue.includes("|")){
                                                        //this field has multiple valid dependant values
                                                        var splitVal = field.dependantValue.split("|");
                                                        var found = splitVal.find(entry=>entry===arrIndex.toString());
                                                        if (found){
                                                            depIsSelected=true;
                                                        }
                                                    }else{
                                                        //this field only has one valid dependant value
                                                        if (field.dependantValue.toString() === arrIndex.toString()) { depIsSelected = true; }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            break;
                    }
                    if (depIsSelected){
                        return(
                            <div key={field.fieldID}>
                                <label className='mt-3'>{parse(field.label)}</label>
                                <TextBox
                                    id={"atolField-"+ field.fieldID}
                                    key={field.fieldID}
                                    value={subContext?.customFieldData[field.fieldID]||""}
                                    onChange={(e)=>handleChange(field.fieldID,e.target.value?.toString() || '')}
                                    maxLength={field.maxLength}
                                    className={'mt-2 atolField-'+field.fieldID.toString()}
                                />
                            </div>
                        )
                    }else{
                        return null;
                    }
                }else{
                    return(
                        <div key={field.fieldID}>
                            <label className='mt-3'>{parse(field.label)}</label>
                            <TextBox
                                id={"atolField-"+ field.fieldID}
                                key={field.fieldID}
                                value={subContext?.customFieldData[field.fieldID]||""}
                                onChange={(e)=>handleChange(field.fieldID,e.target.value?.toString() || '')}
                                maxLength={field.maxLength}
                                className={'mt-2 atolField-'+field.fieldID.toString()}
                            />
                        </div>
                    )
                }
                break;
            case "Phone":
                if (field.dependantField!=0){
//console.log(field.dependantField);
                    const depField = subContext?.fields.find(obj=>obj.fieldID==field.dependantField);
                    var depIsSelected=false;
                    switch (depField?.type){
                        case "RadioButtonList":
                            const selValue = (subContext?.customFieldData[field.dependantField] as unknown) as {index:number, text:string, value:string, weight:string} || {index: -1, text: '', value: '', weight: ''};
                            //console.log(selValue);
                            var selIdx="";
                            if (selValue.index!=null && selValue.index>-1){
                                selIdx = selValue.index.toString();
                            }
                            if (selIdx){
                                if (field.dependantValue.toString().includes("|")){
                                    //multiple dependant values
                                    const depVals = field.dependantValue.toString().split("|");
                                    depVals.forEach(val =>{
                                        if (val === selIdx.toString()){depIsSelected=true;}
                                    })
                                }else{
                                    //just one dependant value
                                    if (field.dependantValue.toString() == selIdx.toString()) { depIsSelected = true; }
                                }
                            }
                            break;
                        case "CheckBoxList":
                            if (subContext){
                                const depFieldVal = subContext.customFieldData[field.dependantField];                                
                                if (depFieldVal){
                                    const arrValue = JSON.parse(depFieldVal) as unknown as Array<customFieldData>
                                    if (arrValue.length>0 && arrValue[0].index!==-1){
                                        arrValue.forEach(obj => {
                                            if (obj.index!=-1){
                                                //console.log(obj);
                                                var arrIndex=obj.index;
                                                if (obj.index){
                                                    if (field.dependantValue.includes("|")){
                                                        //this field has multiple valid dependant values
                                                        var splitVal = field.dependantValue.split("|");
                                                        var found = splitVal.find(entry=>entry===arrIndex.toString());
                                                        if (found){
                                                            depIsSelected=true;
                                                        }
                                                    }else{
                                                        //this field only has one valid dependant value
                                                        if (field.dependantValue.toString() === arrIndex.toString()) { depIsSelected = true; }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            break;
                    }
                    if (depIsSelected){
                        return(
                            <div key={field.fieldID}>
                                <label className='mt-3'>{parse(field.label)}</label>
                                <MaskedTextBox
                                    id={"atolField-"+ field.fieldID}
                                    key={field.fieldID}
                                    mask="000-000-0000"
                                    value={subContext?.customFieldData[field.fieldID]||""}
                                    onChange={(e)=>handleChange(field.fieldID,e.target.value?.toString() || '')}
                                    className={'mt-2 atolField-'+field.fieldID.toString()}
                                />
                            </div>
                        )
                    }else{
                        return null;
                    }
                }else{
                    return(
                        <div key={field.fieldID}>
                            <label className='mt-3'>{parse(field.label)}</label>
                            <MaskedTextBox
                                id={"atolField-"+ field.fieldID}
                                key={field.fieldID}
                                mask="000-000-0000"
                                value={subContext?.customFieldData[field.fieldID]||""}
                                onChange={(e)=>handleChange(field.fieldID,e.target.value?.toString() || '')}
                                className={'mt-2 atolField-'+field.fieldID.toString()}
                            />
                        </div>
                    )
                }
                break;
            case "RadioButtonList":
                const listData = JSON.parse(field.dataSet);
                //console.log(listData);
                if (field.dependantField!=0){
                    //console.log(field.dependantField);
                    const depField = subContext?.fields.find(obj=>obj.fieldID==field.dependantField);
                    var depIsSelected=false;
                    if (depField?.fieldID==13000){
                        console.log(depField);
                    }
                    switch (depField?.type){
                        case "RadioButtonList":
                            const selValue = (subContext?.customFieldData[field.dependantField] as unknown) as customFieldData || {index: -1, text: '', value: '', weight: ''};
                            //console.log(selValue);
                            var selIndex = selValue.index;
                            if (selIndex>-1){
                                if (field.dependantValue.toString().includes("|")){
                                    //multiple dependant values
                                    const depVals = field.dependantValue.toString().split("|");
                                    depVals.forEach(val =>{
                                        if (val === selIndex.toString()){depIsSelected=true;}
                                    })
                                }else{
                                    //just one dependant value
                                    if (field.dependantValue.toString() == selIndex.toString()) { depIsSelected = true; }
                                }
                            }
                            // if (selIndex>-1){
                            //     if (field.dependantValue.toString() === selIndex.toString()) { depIsSelected = true; }
                            // }
                            break;
                        case "CheckBoxList":
                            if (subContext){
                                const depFieldVal = subContext.customFieldData[field.dependantField];                                
                                if (depFieldVal){
                                    const arrValue = JSON.parse(depFieldVal) as unknown as Array<customFieldData>
                                    if (arrValue && arrValue[0].index!==-1){
                                        arrValue.forEach(obj => {
                                            if (obj.index!=-1){
                                                //console.log(obj);
                                                var arrIndex=obj.index;
                                                if (obj.index){
                                                    if (field.dependantValue.includes("|")){
                                                        //this field has multiple valid dependant values
                                                        var splitVal = field.dependantValue.split("|");
                                                        var found = splitVal.find(entry=>entry===arrIndex.toString());
                                                        if (found){
                                                            depIsSelected=true;
                                                        }
                                                    }else{
                                                        //this field only has one valid dependant value
                                                        if (field.dependantValue.toString() === arrIndex.toString()) { depIsSelected = true; }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            
                            break;
                    }                                        
                    if (depIsSelected){  
                        return(
                            <div key={field.fieldID}>
                                <label className='mt-3'>{parse(field.label)}</label>
                                <DropDownList
                                    id={"atolField-"+ field.fieldID}
                                    key={field.fieldID}
                                    data={listData}
                                    textField='text'
                                    dataItemKey='value'
                                    onChange={(e)=>handleDropDownChange(field.fieldID,e)}
                                    value={getRadioValue(field.fieldID)} 
                                    fillMode={"outline"}
                                    className={'mt-2 atolField-'+field.fieldID.toString()}
                                    valid={field.required?validateText(field.fieldID):true}
                                />
                            </div>
                        )
                    }else{
                        //clearDependantValue(field);
                        return null;
                    }
                }else{
                    return(
                        <div key={field.fieldID}>
                            <label className='mt-3'>{parse(field.label)}</label>
                            <DropDownList
                                id={"atolField-"+ field.fieldID}
                                key={field.fieldID}
                                data={listData}
                                textField='text'
                                dataItemKey='value'
                                onChange={(e)=>handleDropDownChange(field.fieldID,e)}
                                value={getRadioValue(field.fieldID)} 
                                fillMode={"outline"}
                                className={'mt-2 atolField-'+field.fieldID.toString()}
                                valid={field.required?validateText(field.fieldID):true}
                            />
                        </div>
                    )
                }
                break;
            case "CheckBoxList":
                const msData = JSON.parse(field.dataSet);
                if (field.dependantField!=0){
                    const depField = subContext?.fields.find(obj=>obj.fieldID==field.dependantField);
                    var depIsSelected=false;
                    switch (depField?.type){
                        case "RadioButtonList":
                            const selValue = (subContext?.customFieldData[field.dependantField] as unknown) as {index:number, text:string, value:string, weight:string} || {index: -1, text: '', value: '', weight: ''};
                            //console.log(selValue);
                            var selIndex = selValue.index;
                            if (selIndex>-1){
                                if (field.dependantValue.toString().includes("|")){
                                    //multiple dependant values
                                    const depVals = field.dependantValue.toString().split("|");
                                    depVals.forEach(val =>{
                                        if (val === selIndex.toString()){depIsSelected=true;}
                                    })
                                }else{
                                    //just one dependant value
                                    if (field.dependantValue.toString() == selIndex.toString()) { depIsSelected = true; }
                                }
                            }
                            //if (field.dependantValue.toString() === selIndex.toString()) { depIsSelected = true; }
                            break;
                        case "CheckBoxList":
                            if (subContext){
                                const depFieldVal = subContext.customFieldData[field.dependantField];                                
                                if (depFieldVal){
                                    const arrValue = JSON.parse(depFieldVal) as unknown as Array<customFieldData>
                                    if (arrValue && arrValue[0].index!==-1){
                                        arrValue.forEach(obj => {
                                            if (obj.index!=-1){
                                                //console.log(obj);
                                                var arrIndex=obj.index;
                                                if (obj.index){
                                                    if (field.dependantValue.includes("|")){
                                                        //this field has multiple valid dependant values
                                                        var splitVal = field.dependantValue.split("|");
                                                        var found = splitVal.find(entry=>entry===arrIndex.toString());
                                                        if (found){
                                                            depIsSelected=true;
                                                        }
                                                    }else{
                                                        //this field only has one valid dependant value
                                                        if (field.dependantValue.toString() === arrIndex.toString()) { depIsSelected = true; }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }                         
                            break;
                    }                                        
                    if (depIsSelected){ 
                        return(
                            <div key={field.fieldID}>
                                <label className='mt-3'>{parse(field.label)}</label>
                                <MultiSelect
                                    id={"atolField-"+ field.fieldID}
                                    key={field.fieldID}
                                    data={msData}
                                    textField='text'
                                    dataItemKey='value'
                                    onChange={(e)=>handleMultiSelectChange(field.fieldID,e)}
                                    value={getMultiValue(field.fieldID)}
                                    fillMode={"outline"}
                                    className={'mt-2 atolField-'+field.fieldID.toString()}
                                    valid={field.required?validateText(field.fieldID):true}
                                />
                            </div>
                        )
                    }else{
                        return null;
                    }
                }else{
                    return(
                        <div key={field.fieldID}>
                            <label className='mt-3'>{parse(field.label)}</label>
                            <MultiSelect
                                id={"atolField-"+ field.fieldID}
                                key={field.fieldID}
                                data={msData}
                                textField='text'
                                dataItemKey='value'
                                onChange={(e)=>handleMultiSelectChange(field.fieldID,e)}
                                value={getMultiValue(field.fieldID)}
                                fillMode={"outline"}
                                className={'mt-2 atolField-'+field.fieldID.toString()}
                                valid={field.required?validateText(field.fieldID):true}
                                disabled={field.readOnly}
                            />
                        </div>
                    )
                }
                break;
            case "ComboBox":
                break;
            case "DatePicker":
                if (field.dependantField!=0){
                    //console.log(field.dependantField);
                    const depField = subContext?.fields.find(obj=>obj.fieldID==field.dependantField);
                    var depIsSelected=false;
                    switch (depField?.type){
                        case "RadioButtonList":
                            const selValue = (subContext?.customFieldData[field.dependantField] as unknown) as {index:number, text:string, value:string, weight:string} || {index: -1, text: '', value: '', weight: ''};
                            //console.log(selValue);
                            var selIdx="";
                            if (selValue.index!=null && selValue.index>-1){
                                selIdx = selValue.index.toString();
                            }
                            if (selIdx){
                                if (field.dependantValue.toString().includes("|")){
                                    //multiple dependant values
                                    const depVals = field.dependantValue.toString().split("|");
                                    depVals.forEach(val =>{
                                        if (val === selIdx.toString()){depIsSelected=true;}
                                    })
                                }else{
                                    //just one dependant value
                                    if (field.dependantValue.toString() == selIdx.toString()) { depIsSelected = true; }
                                }
                            }
                            break;
                        case "CheckBoxList":
                            if (subContext){
                                const depFieldVal = subContext.customFieldData[field.dependantField];                                
                                if (depFieldVal){
                                    const arrValue = JSON.parse(depFieldVal) as unknown as Array<customFieldData>
                                    if (arrValue.length>0 && arrValue[0].index!==-1){
                                        arrValue.forEach(obj => {
                                            if (obj.index!=-1){
                                                //console.log(obj);
                                                var arrIndex=obj.index;
                                                if (obj.index){
                                                    if (field.dependantValue.includes("|")){
                                                        //this field has multiple valid dependant values
                                                        var splitVal = field.dependantValue.split("|");
                                                        var found = splitVal.find(entry=>entry===arrIndex.toString());
                                                        if (found){
                                                            depIsSelected=true;
                                                        }
                                                    }else{
                                                        //this field only has one valid dependant value
                                                        if (field.dependantValue.toString() === arrIndex.toString()) { depIsSelected = true; }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            break;
                    }                                        
                    if (depIsSelected){
                        //dependant value set
                        const id="atolField-"+field.fieldID.toString();
                        console.log(pageContext?.glSettings.Locale);
                        return(
                            <div key={field.fieldID}>
                                <label className='mt-3'>{parse(field.label)}</label>
                                <IntlProvider locale={pageContext?.glSettings.Locale || 'en-US'}>
                                <DatePicker
                                    id={id}
                                    key={field.fieldID}
                                    value={subContext?.customFieldData[field.fieldID] ? new Date(subContext.customFieldData[field.fieldID]) : undefined}
                                    onChange={(e)=>handleChange(field.fieldID, e.target.value?.toString() || '')}
                                    format={pageContext?.glSettings.Locale==="en-GB"||pageContext?.glSettings.Locale==="en-NZ"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                    className={'mt-2 ' + id}  
                                />
                                </IntlProvider>
                            </div>
                        )
                    }else{
                        //clear the value if the dependant field is not set.
                        //clearDependantValue(field);
                        return null;
                    }
                }else{
                    const id="atolField-"+field.fieldID.toString();
                    return(
                        
                        <div key={field.fieldID}>
                            <label className='mt-3'>{parse(field.label)}</label>
                        <IntlProvider locale={pageContext?.glSettings.Locale || 'en-US'}>
                        <DatePicker
                                id={id}
                                key={field.fieldID}
                                value={subContext?.customFieldData[field.fieldID] ? new Date(subContext.customFieldData[field.fieldID]) : undefined}
                                onChange={(e)=>handleChange(field.fieldID, e.target.value?.toString() || '')}
                                className={'mt-2 ' + id}
                                format={pageContext?.glSettings.Locale==="en-GB"||pageContext?.glSettings.Locale==="en-NZ"?"dd/MM/yyyy":"MM/dd/yyyy"}
                            />
                            </IntlProvider>

                        </div>
                    )    
                }
                break;
            case "ColorPicker":
                return(
                    <ColorPicker
                        id={"atolField-"+ field.fieldID}
                        key={field.fieldID}
                        value={subContext?.customFieldData[field.fieldID]||""}
                        onChange={(e)=>handleChange(field.fieldID,e.target.value?.toString() || '')}
                        className={'mt-2 atolField-'+field.fieldID.toString()}
                    />
                )
            case "Label":
                if (field.dependantField!=0){
                    //console.log(field.dependantField);
                    const depField = subContext?.fields.find(obj=>obj.fieldID==field.dependantField);
                    depIsSelected=false;
                    switch (depField?.type){
                        case "RadioButtonList":
                            const selValue = (subContext?.customFieldData[field.dependantField] as unknown) as {index:number, text:string, value:string, weight:string} || {index: -1, text: '', value: '', weight: ''};
                            //console.log(selValue);
                            selIdx="";
                            if (selValue.index!=null && selValue.index>-1){
                                selIdx = selValue.index.toString();
                            }
                            if (selIdx){
                                if (field.dependantValue.toString().includes("|")){
                                    //multiple dependant values
                                    const depVals = field.dependantValue.toString().split("|");
                                    depVals.forEach(val =>{
                                        if (val === selIdx.toString()){depIsSelected=true;}
                                    })
                                }else{
                                    //just one dependant value
                                    if (field.dependantValue.toString() == selIdx.toString()) { depIsSelected = true; }
                                }
                            }
                            break;
                        case "CheckBoxList":
                            if (subContext){
                                const depFieldVal = subContext.customFieldData[field.dependantField];                                
                                if (depFieldVal){
                                    const arrValue = JSON.parse(depFieldVal) as unknown as Array<customFieldData>
                                    if (arrValue.length>0 && arrValue[0].index!==-1){
                                        arrValue.forEach(obj => {
                                            if (obj.index!=-1){
                                                console.log(obj);
                                                var arrIndex=obj.index;
                                                if (obj.index){
                                                    if (field.dependantValue.includes("|")){
                                                        //this field has multiple valid dependant values
                                                        var splitVal = field.dependantValue.split("|");
                                                        var found = splitVal.find(entry=>entry===arrIndex.toString());
                                                        if (found){
                                                            depIsSelected=true;
                                                        }
                                                    }else{
                                                        //this field only has one valid dependant value
                                                        if (field.dependantValue.toString() === arrIndex.toString()) { depIsSelected = true; }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            break;
                    }                                        
                    if (depIsSelected){
                        //dependant value set
                        const id="atolField-"+field.fieldID.toString();
                        return(
                            <div key={field.fieldID}>
                                <label className='mt-3'>{parse(field.label)}</label>                                
                            </div>
                        )
                    }else{
                        return null;
                    }
                }else{
                    const id="atolField-"+field.fieldID.toString();
                    return(
                        
                        <div key={field.fieldID}>
                            <label className='mt-3'>{parse(field.label)}</label>                            
                        </div>
                    )    
                }
                break;
            default:
                return(
                    <></>
                )
        }
    
    }

    

    const prefillFieldVals=()=>{
        if (subContext){
            var element = subContext.submitForm.element;
            getFormResponses(element).then(responses=>{
                if(responses.length>0){
                    console.log(responses);
                    var fieldVals:{[key:number]:string}={}
                    subContext?.fields.map(field=>{
                        if (field.fieldID==90 || field.fieldID==91){
                            console.log(field);
                        }
                        if (field.dataLabel==="ANIMATION_PROMPT"){
                            //Don't lose the animation prompt
                        }else{
                            if (subContext.submitForm.subType==="CR"){
                                if (field.prefillCorrect){    
                                    //This is a correction prefill previous values
                                    var fieldData =JSON.parse(field.dataSet);
                                    var fldArray:Array<customFieldData> =[];
                                    var setVal:string ="";
                                    var listEntry:{ index:number, text: string, value:string, weight:string};
                                    var found: { fieldID:number, value:string} = responses.find((response: { fieldID:number, value:string})=>response.fieldID===field.fieldID);
                                    if (found){
                                        console.log(found);
                                        switch(field.type){
                                            case "TextBox":
                                                fieldVals[field.fieldID] = found.value;
                                                //subContext?.setCustomFieldData({ ...subContext.customFieldData, [field.fieldID]: found.value });
                                                break;
                                            case "RadioButtonList":
                                                if (fieldData){
                                                    //console.log(fieldData);
                                                    listEntry = fieldData.find((entry: { index:number, text: string, value:string, weight:string}) => entry.value === found.value);
                                                    if (listEntry){                                                
                                                        //fldArray.push(listEntry); 
                                                        setVal = JSON.stringify(listEntry);
                                                        fieldVals[field.fieldID] = setVal;
                                                    }
                                                }
                                                break;
                                            case "CheckBoxList":
                                                if (fieldData){
                                                    //console.log(fieldData);
                                                    if (fieldData){
                                                        console.log(fieldData);
                                                        listEntry = fieldData.find((entry: { index:number, text: string, value:string, weight:string}) => entry.value === found.value);
                                                        if (listEntry){                                                
                                                            fldArray.push(listEntry); 
                                                            setVal = JSON.stringify(fldArray);
                                                            fieldVals[field.fieldID] = setVal;
                                                        }
                                                    }
                                                }
                                                break;
                                            case "ComboBox":
                                                if (fieldData){
                                                    //console.log(fieldData);
                                                    if (fieldData){
                                                        console.log(fieldData);
                                                        listEntry = fieldData.find((entry: { index:number, text: string, value:string, weight:string}) => entry.value === found.value);
                                                        if (found){                                                
                                                            fldArray.push(listEntry); 
                                                            setVal = JSON.stringify(fldArray);
                                                            fieldVals[field.fieldID] = setVal;
                                                            //subContext?.setCustomFieldData({ ...subContext.customFieldData, [field.fieldID]: setVal });
                                                        }
                                                    }
                                                }
                                                break;
                                            case "DatePicker":
                                                break;
                                        }
                                    }
                                }
                            }
                        }
                    });
                    if (Object.keys(fieldVals).length > 0){
                        console.log(fieldVals);
                        subContext?.setCustomFieldData(fieldVals);
                        setRespSet(true);
                    }else{
                        setRespSet(true);
                    }
                }else{
                  setRespSet(true);
                }
            });
        }
    }

    const setAnimationPrompt=()=>{
        console.log("Set animation prompt");
        if (subContext){
            var element = subContext.submitForm.element;
            var fieldVals:{[key:number]:string}={}
            subContext?.fields.map(field=>{
                if (field.dataLabel=="ANIMATION_PROMPT"){
                    var size = subContext.submitForm.size[0] as unknown as NewSize;
                    var site = subContext.submitForm.site.code; 
                    var sz = "";
                    if (size.strIn==""){
                        sz=size.size;
                    }else{
                        sz=size.strIn;
                    }
                    console.log(sz);
                    getAnimationPrompt(element,sz,site).then(data=>{
                        //console.log(data);
                        var fieldData =JSON.parse(field.dataSet);
                        if (fieldData){
                            var found = fieldData.find((entry: { index:number, text: string, value:string, weight:string}) => entry.value === data[0]);
                            if (found){
                                console.log(found);
                                var fldArray:Array<customFieldData> =[];
                                fldArray.push(found); 
                                var setVal = JSON.stringify(fldArray);
                                fieldVals[field.fieldID] = setVal;
                                subContext?.setCustomFieldData({ ...subContext.customFieldData, [field.fieldID]: setVal });
                            }
                        }
                    });
                }
            });
        }
    }



    useEffect(()=>{
        handleAIResponse();
    },[asstResponse.current]);

    useEffect(()=>{
        if(fieldsSet==true){
            console.log("Fields updated");
            console.log(subContext?.fields.length + " fields");
            prefillFieldVals();
        }
    },[fieldsSet])

    useEffect(()=>{
        if (respSet==true){
            setAnimationPrompt();
        }
    },[respSet])

   useEffect(()=>{
       console.log(subContext?.customFieldData);
       clearUnusedFieldVals();
   },[subContext?.customFieldData])

    useEffect(() => {
        console.log(subContext?.submitForm);

        getFormFields(subContext?.submitForm.subType, subContext?.submitForm.adType.value,subContext?.submitForm.site.code, subContext?.submitForm.prCheck).then(data=>{
            console.log("Custom Form Set Fields");
            console.log(data);
            //fieldSet=data;
            if (userContext?.user.trusted===false){
                const untrustedFields = data.filter((f: CustomFormField) => f.trustedOnly===false)
                subContext?.setFields(untrustedFields);
            }else{
                subContext?.setFields(data);
            }
            setFieldsSet(true);
        });
    }, []);

    useEffect(()=>{
       console.log("Field:" + asstField);
    },[asstField])

    return(
        <div key="customFields">
            {(subContext?.fields?.length ?? 0) > 0 ? 
                subContext?.fields.map((field)=>(
                <>
                {renderField(field)}
                </>
                )):<p>No additional information is required at this time. Press NEXT to continue.</p>}
            {asstShow?<AdCopyAssistant {...asstProps}/>:null}
        </div>
    )

}

export const SubmitCustom=(
    <div>
        <h5>DETAILS ABOUT THIS AD:</h5>
        <SubmitCustomInfo/>
        <CustomForm/>

    </div>
)